import "./PrivacyPolicy.css";
import ScrollToTop from "../../helpers/ScrollToTop";
import {Breadcrumb} from "../../breadcrumb/Breadcrumb";
import {Container} from "reactstrap";
import {Helmet} from "react-helmet-async";
import {Brand, selectedBrand} from "../../../i18n";
import {PrivacyPolicyCheckWorks} from "./policies/PrivacyPolicyCheckWorks";
import {PrivacyPolicyChecksForFree} from "./policies/PrivacyPolicyChecksForFree";

export const PrivacyPolicy = () => {

	function renderBrandSpecificContent() {
		switch (selectedBrand) {
			case Brand.ChecksForFree:
				return <PrivacyPolicyChecksForFree/>;
			case Brand.CheckWorks:
			default:
				return <PrivacyPolicyCheckWorks/>;
		}
	}

	return (
		<>
			<span className="privacy-policy-page d-flex">
				<Helmet>
					<title>Privacy Policy</title>
					<meta name="description" content="Privacy Policy"/>
				</Helmet>
				<ScrollToTop/>
				<Container>
					<div className="breadcrumb-spacer"/>
					<span className="privacy-policy-container d-flex">
						{renderBrandSpecificContent()}
					</span>
				</Container>
			</span>
		</>
	);
};
